import {
  containerFluid,
  defaultFont,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
  hexToRgb,
} from "assets/jss/material-dashboard-pro-react.js";

const headerStyle = (theme) => ({
  /**
   * Barra superior móvil:
   * - limpia
   * - estable
   * - integrada con la UI
   * - sin transparencia agresiva ni adornos extraños
   */
  appBar: {
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    zIndex: 1200,
    background: `linear-gradient(60deg, ${infoColor[0]}, ${primaryColor[0]})`,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.18)",
    borderBottom: "0",
    color: whiteColor,
    marginBottom: 0,
    borderRadius: 0,
    padding: 0,
    minHeight: 56,
    display: "block",
    transition: "background 150ms ease, box-shadow 150ms ease",

    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  /**
   * Contenedor interno del toolbar móvil.
   */
  container: {
    ...containerFluid,
    minHeight: 56,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1.5),

    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1),
    },
  },

  leftSlot: {
    width: 48,
    minWidth: 48,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },

  centerSlot: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },

  rightSlot: {
    width: 48,
    minWidth: 48,
    flexShrink: 0,
  },

  /**
   * Botón hamburguesa:
   * - discreto
   * - legible
   * - con feedback correcto
   */
  menuButton: {
    width: 40,
    height: 40,
    borderRadius: 10,
    padding: 0,
    color: whiteColor,
    backgroundColor: "transparent",
    transition:
      "background-color 150ms ease, box-shadow 150ms ease, transform 150ms ease",

    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.14)",
    },

    "&:focus": {
      outline: "none",
    },

    "&:focus-visible": {
      backgroundColor: "rgba(255,255,255,0.16)",
      boxShadow: "0 0 0 3px rgba(255,255,255,0.20)",
    },

    "&:active": {
      transform: "scale(0.98)",
    },
  },

  menuIcon: {
    fontSize: "1.4rem",
    color: whiteColor,
  },

  /**
   * Lockup central de marca.
   */
  brandWrap: {
    width: "100%",
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  brandLockup: {
    maxWidth: "100%",
    minWidth: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
  },

  brandLogo: {
    width: 24,
    height: 24,
    flexShrink: 0,
    objectFit: "contain",
    display: "block",
  },

  brandText: {
    ...defaultFont,
    margin: 0,
    color: whiteColor,
    fontWeight: 700,
    fontSize: "0.98rem",
    lineHeight: 1.1,
    letterSpacing: "0.01em",
    textTransform: "none",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.94rem",
    },
  },

  /**
   * Compatibilidad con posibles props de color.
   * No recoloreamos la barra: mantenemos la versión limpia.
   */
  primary: {
    backgroundColor: "rgba(" + hexToRgb(whiteColor) + ", 0.96)",
    color: grayColor[2],
  },

  info: {
    backgroundColor: "rgba(" + hexToRgb(whiteColor) + ", 0.96)",
    color: grayColor[2],
  },

  success: {
    backgroundColor: "rgba(" + hexToRgb(whiteColor) + ", 0.96)",
    color: grayColor[2],
  },

  warning: {
    backgroundColor: "rgba(" + hexToRgb(whiteColor) + ", 0.96)",
    color: grayColor[2],
  },

  danger: {
    backgroundColor: "rgba(" + hexToRgb(whiteColor) + ", 0.96)",
    color: grayColor[2],
  },

  /**
   * Clases heredadas por compatibilidad.
   */
  flex: {
    flex: 1,
  },

  title: {
    ...defaultFont,
    lineHeight: "1.2",
    fontSize: "1rem",
    fontWeight: 700,
    textTransform: "none",
    color: grayColor[2],
    padding: 0,
    margin: 0,
    letterSpacing: "0.01em",
    "&:hover,&:focus": {
      background: "transparent",
    },
  },

  sidebarMinimize: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: grayColor[2],
    padding: 0,
  },

  sidebarMinimizeRTL: {
    padding: "0 !important",
  },

  sidebarMiniIcon: {
    width: 20,
    height: 20,
    color: grayColor[2],
  },
});

export default headerStyle;